<template>
  <div class="ad-page">
    <HpsfirProPageHeader
      title="一店一码顶部"
      title-en="STORE TOP"
      description="配置一店一码页面顶部广告位。"
    />
    <div class="ad-page__content">
      <Advertising position="storetop"/>
    </div>
  </div>
</template>
<script lang="ts" setup>
import Advertising from '@/components/Advertising.vue';
</script>
<style lang="scss" scoped>
.ad-page {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__content {
    padding: 0 16px 16px;
  }

  @media (max-width: 767px) {
    gap: 12px;

    &__content {
      padding: 0 8px 12px;
    }
  }
}
</style>
